import React, { Component } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';
import moment from 'moment';
import { EVENT_GET_DETAIL_BOT_LOG } from '../../configs/EventTypes';

var base64 = require('base-64');
var utf8 = require('utf8');

class SearchTablePage extends Component {
    constructor(props) {
        super(props);

        this.state = {
            searchResult: [],
            page: 0,
            rowsPerPage: 10,

        }
        this.handlerClick = this.handlerClick.bind(this);
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.tablesearch !== this.state.searchResult) {

            this.setState({
                searchResult: nextProps.tablesearch,
                page: 0
            })
        }
    }

    handleChangePage(event, newPage, pageName) {
        this.setState({
            [pageName]: newPage
        })
    }

    handleChangeRowsPerPage(event, pageName, rowsPerPageName) {
        this.setState({
            [rowsPerPageName]: +event.target.value,
            [pageName]: 0
        })
    }

    handlerClick(rowIndex, transactionNo) {

        //console.log(rowIndex)
        //console.log(transaction_no)

        const { searchResult } = this.state;
        let { history } = this.props;
        if (transactionNo !== '') {
            var clickRowOntask = searchResult.filter((data) => {
                return data.transaction_no && data.transaction_no === transactionNo
            })

            if (clickRowOntask.length > 0) {

                let bytes_tran_no = utf8.encode(clickRowOntask[0].transaction_no);
                let encoded_transaction_no = base64.encode(bytes_tran_no);

                let bytes_po_contract_no = utf8.encode(clickRowOntask[0].po_contract_no);
                let encoded_po_contract_no = base64.encode(bytes_po_contract_no)

                history.push({
                    pathname: '/main',
                    search: `?mode=EDIT&transaction_no=${encoded_transaction_no}&po_no=${encoded_po_contract_no}`,
                    state: { searchResult: clickRowOntask[0], mode: 'EDIT' }
                });
            }
        }
    }

    setDetailBotLogModal(type, transaction_no = "") {

        window.emitter.emit(EVENT_GET_DETAIL_BOT_LOG, {
            transaction_no: transaction_no
        })

        window.$('#DetailBotLogModal').modal('show');
    }

    render() {

        const { searchResult, page, rowsPerPage } = this.state
        const { isAdmin } = this.props
        console.log("searchResult")
        console.log(searchResult)
        return (
            <Paper style={ { display: 'flex', flex: '1' } }>
                <div className="row no-gutters sp-table-content ">
                    <Table className="sp-table table rrs-table">
                        <TableHead>
                        <TableRow className="sp-table-header">

                                <TableCell className="th-table text-center" style={{ width: '70px' }} >PO/Contract No.</TableCell>
                                <TableCell className="th-table text-center" style={{ width: '70px' }} >MOM Doc No.</TableCell>
                                <TableCell className="th-table text-center" style={{ width: '70px' }} >RRS Doc No.</TableCell>

                                <TableCell className="th-table text-center"  style={{ width: '450px' }}>Header Text</TableCell>
                                <TableCell className="th-table text-center" style={{ width: '100px'  }} >Action Date</TableCell>
                                <TableCell className="th-table text-center" style={{ width: '40px',"white-space": "pre-line"  }} >Days Outstanding</TableCell>
                                <TableCell className="th-table text-center" style={{ width: '150px'  }} >Action By</TableCell>
                                <TableCell className="th-table text-center" style={{ width: '150px'   }} >Status</TableCell>

                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {
                                searchResult ? (
                                    searchResult.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                        .map((task, index) => {
                                            return (
                                                <TableRow key={index}>
                                                    <TableCell className="text-center" >{task.po_contract_no}</TableCell>
                                                    <TableCell className="text-center" >{task.mom_no}</TableCell>
                                                    <TableCell className="text-center" >{task.doc_no}</TableCell>
                                                    <TableCell className="text-left">{task.document_name}</TableCell>
                                                    <TableCell  className="text-center">{task.action_date ? moment(task.action_date).format('DD/MM/YYYY') : ''}</TableCell>
                                                    <TableCell className="text-center" >{task.days_outstanding}</TableCell>
                                                    <TableCell className="text-center" >{task.action_by_name}</TableCell>
                                                    <TableCell className="text-center" >{task.status_name}</TableCell>

                                                    
                                                </TableRow>
                                            );
                                        })) : (
                                    <TableRow key={0}>
                                        <TableCell colSpan="11" className="text-center" style={{
                                            textAlign: 'center',
                                            fontStyle: 'italic',
                                            color: 'gray'
                                        }}>No data</TableCell>
                                    </TableRow>
                                )
                            }

                        </TableBody>
                    </Table>
                    <TablePagination
                        rowsPerPageOptions={[10, 25, 50, 100]}
                        component="div"
                        count={searchResult.length}
                        rowsPerPage={this.state.rowsPerPage}
                        page={this.state.page}
                        backIconButtonProps={{
                            'aria-label': 'previous page',
                        }}
                        nextIconButtonProps={{
                            'aria-label': 'next page',
                        }}
                        onChangePage={(event, newPage) => this.handleChangePage(event, newPage, "page")}
                        onChangeRowsPerPage={(event) => this.handleChangeRowsPerPage(event, "page", "rowsPerPage")}
                    />
                </div>
            </Paper>
        );

    }


}
export default SearchTablePage